/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectGroupsControllerGetProjectGroupsQueryResponse, ProjectGroupsControllerGetProjectGroupsPathParams, ProjectGroupsControllerGetProjectGroupsQueryParams, ProjectGroupsControllerGetProjectGroups400, ProjectGroupsControllerGetProjectGroups401, ProjectGroupsControllerGetProjectGroups403 } from "../../models/projectGroupsController/ProjectGroupsControllerGetProjectGroups";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { projectGroupsControllerGetProjectGroups } from "../../clients/project-groupsService/projectGroupsControllerGetProjectGroups";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const projectGroupsControllerGetProjectGroupsQueryKey = (teamId: ProjectGroupsControllerGetProjectGroupsPathParams["teamId"], params: ProjectGroupsControllerGetProjectGroupsQueryParams) => [{
  url: '/api/v1/teams/:teamId/project-groups',
  params: {
    teamId: teamId
  }
}, ...(params ? [params] : [])] as const;
export type ProjectGroupsControllerGetProjectGroupsQueryKey = ReturnType<typeof projectGroupsControllerGetProjectGroupsQueryKey>;
export function projectGroupsControllerGetProjectGroupsQueryOptions(teamId: ProjectGroupsControllerGetProjectGroupsPathParams["teamId"], params: ProjectGroupsControllerGetProjectGroupsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = projectGroupsControllerGetProjectGroupsQueryKey(teamId, params);
  return queryOptions<ProjectGroupsControllerGetProjectGroupsQueryResponse, ResponseErrorConfig<ProjectGroupsControllerGetProjectGroups400 | ProjectGroupsControllerGetProjectGroups401 | ProjectGroupsControllerGetProjectGroups403>, ProjectGroupsControllerGetProjectGroupsQueryResponse, typeof queryKey>({
    enabled: !!(teamId && params),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return projectGroupsControllerGetProjectGroups(teamId, params, config);
    }
  });
}

/**
 * @summary Get project groups by field for a team
 * {@link /api/v1/teams/:teamId/project-groups}
 */
export function useProjectGroupsControllerGetProjectGroups<TData = ProjectGroupsControllerGetProjectGroupsQueryResponse, TQueryData = ProjectGroupsControllerGetProjectGroupsQueryResponse, TQueryKey extends QueryKey = ProjectGroupsControllerGetProjectGroupsQueryKey>(teamId: ProjectGroupsControllerGetProjectGroupsPathParams["teamId"], params: ProjectGroupsControllerGetProjectGroupsQueryParams, options: {
  query?: Partial<QueryObserverOptions<ProjectGroupsControllerGetProjectGroupsQueryResponse, ResponseErrorConfig<ProjectGroupsControllerGetProjectGroups400 | ProjectGroupsControllerGetProjectGroups401 | ProjectGroupsControllerGetProjectGroups403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? projectGroupsControllerGetProjectGroupsQueryKey(teamId, params);
  const query = useQuery({
    ...projectGroupsControllerGetProjectGroupsQueryOptions(teamId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ProjectGroupsControllerGetProjectGroups400 | ProjectGroupsControllerGetProjectGroups401 | ProjectGroupsControllerGetProjectGroups403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}